export function checkDate(date) {
    var limit = 0;
    var check = false;
    var chk_date = date.split("/");
    if(chk_date.length === 3){
        var chk_year = chk_date[0];
        var chk_month = chk_date[1];
        var chk_day = chk_date[2];
        let days30_month = [4,6,9,11];
        if (chk_year != "0000" && chk_year.length === 4 &&
            chk_month != "00" && chk_month.length < 3 &&
            chk_day != "00" && chk_day.length < 3 &&
            !isNaN(Date.parse(date))) {
            if (chk_month == 2) { // 閏年チェック
                if ( (0 == chk_year % 4 && 0 != chk_year % 100) || 0 == chk_year % 400 ) {
                    limit = 29;
                }
                else {
                    limit = 28;
                }
                if (chk_day <= limit) {
                    check = true;
                }
            }
            else if(days30_month.includes(Number(chk_month))){
                if( chk_day <= 30){
                    check = true;
                }
            }
            else {
                check = true;
            }
        }
    }
    return check;
}